(function () {
  'use strict';

  function formatMoney(cents) {
    var format = window.__ptlMoneyFormat || window.theme?.moneyFormat;
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && format) {
      return Shopify.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function findVariant(variants, selectedOptions) {
    return variants.find(function (variant) {
      return (
        (!selectedOptions[1] || variant.option1 === selectedOptions[1]) &&
        (!selectedOptions[2] || variant.option2 === selectedOptions[2]) &&
        (!selectedOptions[3] || variant.option3 === selectedOptions[3])
      );
    });
  }

  function getSelectedOptions(sectionEl) {
    var selected = {};
    sectionEl.querySelectorAll('.variant-pill__input:checked').forEach(function (input) {
      var pos = input.getAttribute('data-option-position');
      if (pos) selected[pos] = input.value;
    });
    return selected;
  }

  function initMediaCarousel(sectionEl) {
    var carousel = sectionEl.querySelector('[data-media-carousel]');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.product-media__slide');
    var dots = sectionEl.querySelectorAll('.product-media__dot');
    var count = slides.length;

    if (count === 0) return;

    function getActiveIndex() {
      var scrollLeft = carousel.scrollLeft;
      var center = scrollLeft + carousel.clientWidth / 2;
      var active = 0;
      var minDist = Infinity;

      slides.forEach(function (slide, i) {
        var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        var dist = Math.abs(center - slideCenter);
        if (dist < minDist) {
          minDist = dist;
          active = i;
        }
      });

      return active;
    }

    function setActiveIndex(index) {
      if (index < 0 || index >= count) return;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });

      dots.forEach(function (dot, i) {
        var isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function scrollToIndex(index, smooth) {
      var slide = slides[index];
      if (!slide) return;

      var target =
        slide.offsetLeft - (carousel.clientWidth - slide.offsetWidth) / 2;

      carousel.scrollTo({
        left: Math.max(0, target),
        behavior: smooth !== false ? 'smooth' : 'auto',
      });

      setActiveIndex(index);
    }

    var scrollTimeout;
    carousel.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          setActiveIndex(getActiveIndex());
        }, 60);
      },
      { passive: true }
    );

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-slide-index'), 10);
        scrollToIndex(index);
      });
    });

    setActiveIndex(getActiveIndex());

    return {
      scrollToMediaId: function (mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
            scrollToIndex(i);
            return;
          }
        }
      },
    };
  }

  function initProductTieredSection(sectionEl) {
    var carouselApi = initMediaCarousel(sectionEl);
    var variantInput = sectionEl.querySelector('[data-variant-input]');
    var priceEl = sectionEl.querySelector('[data-product-price]');
    var mobileAdd = sectionEl.querySelector('[data-mobile-add]');
    var mainAddBtn = sectionEl.querySelector('[data-add-to-cart]');
    var variantsJson = sectionEl.querySelector('[data-product-variants]');
    var currencyCode = sectionEl.getAttribute('data-currency-code') || '';

    if (!variantsJson) return;

    var variants;
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      return;
    }

    function updateVariantUI(variant) {
      if (!variant) return;

      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var priceText = formatMoney(variant.price);
      if (currencyCode && !priceText.includes(currencyCode)) {
        priceText = priceText + ' ' + currencyCode;
      }
      if (priceEl) priceEl.textContent = priceText;

      if (mainAddBtn) {
        mainAddBtn.disabled = !variant.available;
        mainAddBtn.textContent = variant.available
          ? mainAddBtn.dataset.labelDefault || mainAddBtn.textContent
          : 'Sold out';
      }

      if (mobileAdd) {
        mobileAdd.disabled = !variant.available;
      }

      var featuredImg = variant.featured_image || variant.featured_media;
      if (featuredImg && carouselApi) {
        var mediaId = featuredImg.id || featuredImg.media_id;
        if (mediaId) {
          carouselApi.scrollToMediaId(mediaId);
        }
      }

      sectionEl.querySelectorAll('.variant-pill').forEach(function (pill) {
        pill.classList.remove('is-selected');
      });
      sectionEl.querySelectorAll('.variant-pill__input:checked').forEach(function (input) {
        var pill = input.closest('.variant-pill');
        if (pill) pill.classList.add('is-selected');
      });
    }

    if (mainAddBtn && !mainAddBtn.dataset.labelDefault) {
      mainAddBtn.dataset.labelDefault = mainAddBtn.textContent.trim();
    }

    sectionEl.querySelectorAll('.variant-pill__input').forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = getSelectedOptions(sectionEl);
        var variant = findVariant(variants, selected);
        if (!variant && input.getAttribute('data-variant-id')) {
          variant = variants.find(function (v) {
            return String(v.id) === String(input.getAttribute('data-variant-id'));
          });
        }
        updateVariantUI(variant);
      });
    });

    if (mobileAdd && mainAddBtn) {
      mobileAdd.addEventListener('click', function () {
        if (!mainAddBtn.disabled) mainAddBtn.click();
      });
    }

    var initial = findVariant(variants, getSelectedOptions(sectionEl));
    if (initial) updateVariantUI(initial);
  }

  function initAll() {
    document.querySelectorAll('[data-product-tiered-section]').forEach(initProductTieredSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-product-tiered-section]');
    if (section) initProductTieredSection(section);
  });
})();
